import { useMatch } from "react-router-dom";
import { listAndDetailSamplesRoutes, listAndDetailSamplesRoutesCombined } from "../../ListAndDetailSamplesNavigation";
import { ListAndDetailSampleEditForm } from "../ListAndDetailSampleEditForm";

export const ListAndDetailSamplesFiltersEditPage = () => {

    const match = useMatch(listAndDetailSamplesRoutesCombined.filters_editMatch);
    const cityTownCode = match?.params.cityTownCode;

    return (
        <ListAndDetailSampleEditForm
            listUrl={listAndDetailSamplesRoutes.filters}
            cityTownCode={cityTownCode}
        />
    )
}
